"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TimeGeneralHandler", {
    enumerable: true,
    get: function() {
        return TimeGeneralHandler;
    }
});
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _utc = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/utc.js"));
const _catchError = require("src/helpers/catchError");
const _generic = require("~/db/field-handler/handlers/generic");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
_dayjs.default.extend(_utc.default);
let TimeGeneralHandler = class TimeGeneralHandler extends _generic.GenericFieldHandler {
    getTimeFormat() {
        return 'YYYY-MM-DD HH:mm:ssZ';
    }
    async parseUserInput(params) {
        var _params_value;
        if (params.value === null || params.value === undefined || params.value === '') {
            return {
                value: null
            };
        }
        let parsedTime;
        const value = (_params_value = params.value) == null ? void 0 : _params_value.toString().trim();
        // Try parsing as full datetime first (e.g., "1999-01-01 01:00:00+05:30")
        parsedTime = (0, _dayjs.default)(value);
        // If not valid, try parsing as time only with HH:mm:ss format
        if (!parsedTime.isValid()) {
            parsedTime = (0, _dayjs.default)(value, 'HH:mm:ss');
        }
        // If still not valid, prepend a date to help parse the time
        if (!parsedTime.isValid()) {
            parsedTime = (0, _dayjs.default)(`1999-01-01 ${value}`);
        }
        // If still invalid, throw an error
        if (!parsedTime.isValid()) {
            _catchError.NcError.invalidValueForField({
                value: params.value,
                column: params.column.title,
                type: params.column.uidt
            });
        }
        return {
            value: parsedTime.format(this.getTimeFormat())
        };
    }
    async verifyFilter(filter, column) {
        const supportedOperations = [
            'eq',
            'neq',
            'not',
            'empty',
            'notempty',
            'null',
            'notnull',
            'blank',
            'notblank',
            'gt',
            'lt',
            'gte',
            'lte',
            'ge',
            'le',
            'btw',
            'nbtw',
            'gb_eq',
            'gb_null'
        ];
        if (!supportedOperations.includes(filter.comparison_op)) {
            return {
                isValid: false,
                errors: [
                    `Operation ${filter.comparison_op} is not supported for type ${column.uidt} on column ${column.title}`
                ]
            };
        }
        // For comparison operations that need a value, validate the time format
        if ([
            'eq',
            'neq',
            'not',
            'gt',
            'lt',
            'gte',
            'lte',
            'ge',
            'le',
            'gb_eq'
        ].includes(filter.comparison_op) && filter.value) {
            // Try to parse the filter value as time
            let parsedTime = (0, _dayjs.default)(filter.value);
            if (!parsedTime.isValid()) {
                parsedTime = (0, _dayjs.default)(filter.value, 'HH:mm:ss');
            }
            if (!parsedTime.isValid()) {
                parsedTime = (0, _dayjs.default)(`1999-01-01 ${filter.value}`);
            }
            if (!parsedTime.isValid()) {
                return {
                    isValid: false,
                    errors: [
                        `Value ${filter.value} is not a valid time for column ${column.title}`
                    ]
                };
            }
        }
        return {
            isValid: true
        };
    }
    async filter(knex, filter, column, options) {
        var _options_customWhereClause;
        const { alias } = options;
        const val = filter.value;
        const field = (_options_customWhereClause = options.customWhereClause) != null ? _options_customWhereClause : alias ? `${alias}.${column.column_name}` : column.column_name;
        // Parse the filter value to ensure it's in the correct format
        let parsedVal = val;
        if (val && typeof val === 'string') {
            let parsedTime = (0, _dayjs.default)(val);
            if (!parsedTime.isValid()) {
                parsedTime = (0, _dayjs.default)(val, 'HH:mm:ss');
            }
            if (!parsedTime.isValid()) {
                parsedTime = (0, _dayjs.default)(`1999-01-01 ${val}`);
            }
            if (parsedTime.isValid()) {
                parsedVal = parsedTime.format(this.getTimeFormat());
            }
        }
        return await this.handleFilter({
            val: parsedVal,
            sourceField: field
        }, {
            knex,
            filter,
            column
        }, options);
    }
};
